import useCountUp from '../hooks/useCountUp';

// Sunucu sağlık skoru halkası (0-100).
export default function HealthRing({ score = 0, label = 'ok', size = 148, stroke = 12 }) {
  const n = useCountUp(score, { duration: 1100 });
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score)) / 100;
  const tone = label === 'crit' ? 'var(--crit)' : label === 'warn' ? 'var(--warn)' : 'var(--ok)';

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--border)" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={tone} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
          style={{ transition: 'stroke-dashoffset 1.1s cubic-bezier(.22,1,.36,1)' }}
        />
      </svg>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontFamily: '"Space Grotesk", sans-serif', fontSize: size * 0.32, fontWeight: 600, lineHeight: 1, color: tone }}>
          {Math.round(n)}
        </span>
        <span style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 2 }}>/ 100</span>
      </div>
    </div>
  );
}
